import React from 'react';

const ChevronDown = (props: any) => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 0.954102L5.00229 4.9541L9 0.9541" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ChevronDown;
